<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M25.43 18.79a1 1 0 00-.86 1.81c1.55.73 2.43 1.6 2.43 2.4 0 1.89-4.7 4-11 4S5 24.89 5 23c0-.8.88-1.67 2.43-2.4a1 1 0 00-.86-1.81C4.27 19.88 3 21.37 3 23c0 3.42 5.59 6 13 6s13-2.58 13-6c0-1.63-1.27-3.12-3.57-4.21z"/><path d="M14.59 20a2 2 0 00.48.35 1 1 0 001.86 0 2 2 0 00.48-.35l3.8-3.79a1 1 0 00-1.42-1.42L17 17.59V4a1 1 0 00-2 0v13.59l-2.79-2.8a1 1 0 00-1.42 1.42z"/></svg>